import React from "react";

export default function CustomerInfoCard({ name, email, phone }) {
  return (
    <div className="bg-white rounded-xl p-4 sm:p-6 border border-gray-200 mt-6">
      {/* CUSTOMER NAME */}
      <h3 className="text-base sm:text-lg font-semibold text-gray-900">
        {name || "-"}
      </h3>

      {/* DETAILS */}
      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
        {/* EMAIL */}
        <div>
          <p className="text-xs sm:text-sm text-gray-500">Email</p>
          <p className="text-gray-800 font-medium break-all">{email || "-"}</p>
        </div>

        {/* PHONE */}
        <div>
          <p className="text-xs sm:text-sm text-gray-500">Phone</p>
          <p className="text-gray-800 font-medium">{phone || "-"}</p>
        </div>
      </div>
    </div>
  );
}
